import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M18.8 10.2083C18.8 9.55833 18.7417 8.93333 18.6333 8.33333H10V11.8833H14.9333C14.7167 13.025 14.0667 13.9917 13.0917 14.6417V16.95H16.0667C17.8 15.35 18.8 13 18.8 10.2083Z",
      fill: "#4285F4"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10 19.1667C12.475 19.1667 14.55 18.35 16.0667 16.95L13.0917 14.6417C12.275 15.1917 11.2333 15.525 10 15.525C7.61667 15.525 5.59167 13.9167 4.86667 11.75H1.81667V14.1167C3.325 17.1083 6.41667 19.1667 10 19.1667Z",
      fill: "#34A853"
    }, null, -1),
    _createElementVNode("path", {
      d: "M4.86667 11.7417C4.68333 11.1917 4.575 10.6083 4.575 10C4.575 9.39166 4.68333 8.80833 4.86667 8.25833V5.89166H1.81667C1.19167 7.125 0.833333 8.51666 0.833333 10C0.833333 11.4833 1.19167 12.875 1.81667 14.1083L4.19167 12.2583L4.86667 11.7417Z",
      fill: "#FBBC05"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10 4.48333C11.35 4.48333 12.55 4.94999 13.5083 5.84999L16.1333 3.22499C14.5417 1.74166 12.475 0.833328 10 0.833328C6.41667 0.833328 3.325 2.89166 1.81667 5.89166L4.86667 8.25833C5.59167 6.09166 7.61667 4.48333 10 4.48333Z",
      fill: "#EA4335"
    }, null, -1)
  ]))]))
}
export default { render: render }